// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "registeredPassenger__downloadButton-1ZLK6";
export { _1 as "__esModule", _2 as "registeredPassenger__downloadButton" }
export default { "__esModule": _1, "registeredPassenger__downloadButton": _2 }
